const sessionDbSyncedKeys = new Set<string>();

function categoriesKey(workspaceId: string, gradeId: string): string {
  return `ws:${workspaceId.trim()}:grade:${gradeId.trim()}:categories`;
}

function bundleKey(workspaceId: string, gradeId: string, categoryName: string): string {
  return `ws:${workspaceId.trim()}:grade:${gradeId.trim()}:bundle:${categoryName.trim()}`;
}

export function isWorkspaceEvaluationPlanCategoriesSessionDbSynced(
  workspaceId: string,
  gradeId: string
): boolean {
  const ws = workspaceId.trim();
  const gid = gradeId.trim();
  if (!ws || !gid) return false;
  return sessionDbSyncedKeys.has(categoriesKey(ws, gid));
}

export function markWorkspaceEvaluationPlanCategoriesSessionDbSynced(
  workspaceId: string,
  gradeId: string
): void {
  const ws = workspaceId.trim();
  const gid = gradeId.trim();
  if (!ws || !gid) return;
  sessionDbSyncedKeys.add(categoriesKey(ws, gid));
}

export function isWorkspaceEvaluationPlanBundleSessionDbSynced(
  workspaceId: string,
  gradeId: string,
  categoryName: string
): boolean {
  const ws = workspaceId.trim();
  const gid = gradeId.trim();
  const name = categoryName.trim();
  if (!ws || !gid || !name) return false;
  return sessionDbSyncedKeys.has(bundleKey(ws, gid, name));
}

export function markWorkspaceEvaluationPlanBundleSessionDbSynced(
  workspaceId: string,
  gradeId: string,
  categoryName: string
): void {
  const ws = workspaceId.trim();
  const gid = gradeId.trim();
  const name = categoryName.trim();
  if (!ws || !gid || !name) return;
  sessionDbSyncedKeys.add(bundleKey(ws, gid, name));
}

export function invalidateWorkspaceEvaluationPlanBundleSessionDbSynced(
  workspaceId: string,
  gradeId: string,
  categoryName: string
): void {
  const ws = workspaceId.trim();
  const gid = gradeId.trim();
  const name = categoryName.trim();
  if (!ws || !gid || !name) return;
  sessionDbSyncedKeys.delete(bundleKey(ws, gid, name));
}
